// extracted by mini-css-extract-plugin
module.exports = {"projects":"Projects_projects__g5xdJ","heading":"Projects_heading__CtS7W"};